import React from "react";

export const AirConditioning = ({className}) => {
  return (
    <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="currentcolor"
    ariaHidden="true"
    display="block"
    viewBox="0 0 32 32"
    style={{ height: 24, width: 24 }}
    className={className}
  >
    <path d="M17 1v4.03l4.026-2.324 1 1.732L17 7.339v6.928l6-3.464V5h2v4.648l3.49-2.014 1 1.732L26 11.381l4.026 2.325-1 1.732L24 12.535l-6 3.464 6 3.465 5.026-2.902 1 1.732L26 20.618l3.49 2.016-1 1.732L25 22.351V27h-2v-5.804l-6-3.465v6.929l5.026 2.902-1 1.732L17 26.97V31h-2v-4.031l-4.026 2.325-1-1.732L15 24.66v-6.929l-6 3.464V27H7v-4.65l-3.49 2.016-1-1.732 3.489-2.016-4.025-2.324 1-1.732 5.025 2.901 6-3.464-6-3.464-5.025 2.903-1-1.732L6 11.38 2.51 9.366l1-1.732L7 9.648V5h2v5.803l6 3.464V7.339L9.974 4.438l1-1.732L15 5.03V1z"></path>
  </svg>
  );
}

export const Avatar = ({ className, onClick, color }) => {
  return  <svg
      xmlns="http://www.w3.org/2000/svg"
      x="0"
      y="0"
      enableBackground="new 0 0 512 512"
      version="1.1"
      viewBox="0 0 512 512"
      xmlSpace="preserve"
      className={className}
      onClick={onClick}
    >
      <path fill={color} d="M333.187 237.405c32.761-23.893 54.095-62.561 54.095-106.123C387.282 58.893 328.389 0 256 0S124.718 58.893 124.718 131.282c0 43.562 21.333 82.23 54.095 106.123-81.44 31.165-139.428 110.126-139.428 202.39 0 39.814 32.391 72.205 72.205 72.205h288.82c39.814 0 72.205-32.391 72.205-72.205 0-92.264-57.988-171.225-139.428-202.39zM164.103 131.282c0-50.672 41.225-91.897 91.897-91.897s91.897 41.225 91.897 91.897S306.672 223.18 256 223.18s-91.897-41.226-91.897-91.898zM400.41 472.615H111.59c-18.097 0-32.82-14.723-32.82-32.821 0-97.726 79.504-177.231 177.231-177.231s177.231 79.504 177.231 177.231c-.001 18.098-14.724 32.821-32.822 32.821z"></path>
    </svg>
};

export const Balcony = ({className}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="currentcolor"
      ariaHidden="true"
      display="block"
      viewBox="0 0 32 32"
      className={className}
      style={{ height: 24, width: 24 }}
    >
      <path d="M23 1a2 2 0 011.995 1.85L25 3v16h4v2h-2v8h2v2H3v-2h2v-8H3v-2h4V3a2 2 0 011.85-1.995L9 1zM9 21H7v8h2zm4 0h-2v8h2zm4 0h-2v8h2zm4 0h-2v8h2zm4 0h-2v8h2zm-10-8H9v6h6zm8 0h-6v6h6zM15 3H9v8h6zm8 0h-6v8h6z"></path>
    </svg>
  );
}
export const Bathtub = ({className}) => {
  return (
    <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="currentcolor"
    ariaHidden="true"
    display="block"
    viewBox="0 0 32 32"
      className={className}
      style={{ height: 24, width: 24 }}
  >
    <path d="M7.5 2a4.5 4.5 0 014.473 4H14v2H8V6h1.95a2.5 2.5 0 00-4.945.336L5 6.5V16h26v2h-2v5a5.001 5.001 0 01-3 4.584V30h-2v-2H8v2H6v-2.416a5.002 5.002 0 01-2.995-4.349L3 23v-5H1v-2h2V6.5A4.5 4.5 0 017.5 2zm19.499 16h-22L5 23a3 3 0 002.65 2.98l.174.015L8 26h16a3 3 0 002.995-2.824L27 23z"></path>
  </svg>
  );
}

export const Calendar = ({className}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      x="0"
      y="0"
      enableBackground="new 0 0 310.958 310.958"
      version="1.1"
      viewBox="0 0 310.958 310.958"
      xmlSpace="preserve"
      className={className}
    >
      <g fill="#010002">
        <path d="M17.745 50.7c-2.692 2.187-4.514 5.526-4.509 10.057.136 78.578 3.492 157.118 3.628 235.691.011 7.685 6.19 13.239 13.598 13.598 44.742 2.187 89.451-.005 134.165-1.882 22.355-.936 44.709-1.632 67.08-1.746 14.038-.071 34.951 4.52 47.586-4.139 17.459-11.971 17.302-32.988 18.096-52.59 1.207-29.92-1.12-60.064-3.013-89.913-1.447-22.784-1.148-44.269-.114-67.064 1.088-23.997-1.86-44.084-28.218-49.001-13.152-2.453-26.635-2.23-40.167-1.333V13.464c0-17.536-27.195-17.536-27.195 0v31.057c-6.331.468-12.635.832-18.874.848-20.93.044-41.854.348-62.778.685-.294-12.086-1.099-24.139-3.144-36.202-2.926-17.263-29.126-9.92-26.222 7.229 1.648 9.72 2.241 19.543 2.42 29.387-21.082.337-42.164.653-63.251.691-3.921.006-6.923 1.42-9.088 3.541zM269.28 264.798c-1.115 13.527-2.203 14.729-16.502 15.137-69.098 1.985-139.594 5.896-208.855 3.399-.283-46.558-1.447-93.106-2.393-139.659 74.776-1.98 149.667-3.519 224.47-3.688.326 6.576.756 13.157 1.18 19.787 1.556 24.226 2.915 48.462 3.198 72.737.126 10.781-.206 21.545-1.098 32.287zM89.954 73.93c-.022 2.056-.049 4.112-.054 6.162-.071 17.541 27.125 17.536 27.195 0 .005-2.181.022-4.362.038-6.538 27.201-.451 54.38-1.224 81.548-2.339v10.236c0 17.536 27.195 17.536 27.195 0V70.013c2.143-.109 4.291-.169 6.44-.283 5.026-.272 32.449-3.285 34.261 3.416 3.095 11.46.218 26.45-.587 38.122-.033.511-.022 1.023-.054 1.528-74.956.174-149.993 1.719-224.922 3.699-.234-14.065-.348-28.136-.435-42.207a6718.92 6718.92 0 0049.375-.358z"></path>
        <path d="M96.802 158.029c-6.103-8.05-17.65-3.367-25.999-3.367-2.35 0-4.047.99-5.14 2.42-.984 1.072-1.637 2.513-1.659 4.378-.114 9.149-2.051 19.738 6.244 25.993 3.106 2.344 8.605 1.615 12.189 1.273 4.03-.386 8.039-1.061 12.026-1.735 2.132-.359 4.346-2.649 4.748-4.748.718-3.78.479-7.702.239-11.515-.233-3.833-.19-9.463-2.648-12.699zm-12.303 16.867c-1.681.223-3.378.37-5.069.473-.587.033-1.18.049-1.773.049-.321-1.267-.337-2.6-.364-3.9-.033-1.305.033-2.605.087-3.911 2.828-.419 5.651-.843 8.099-.702.179 1.169.288 2.502.386 3.835.098 1.305.114 2.611.152 3.922-.512.065-1.012.163-1.518.234zM96.802 199.317c-6.097-8.05-17.655-3.367-25.999-3.367-2.35 0-4.047.99-5.14 2.42-.984 1.071-1.637 2.513-1.659 4.378-.114 9.154-2.056 19.744 6.244 25.999 3.106 2.344 8.605 1.615 12.189 1.273 4.03-.386 8.039-1.061 12.026-1.735 2.132-.359 4.346-2.649 4.748-4.748.718-3.78.479-7.702.239-11.514-.233-3.835-.195-9.459-2.648-12.706zm-12.303 16.866c-1.681.223-3.378.37-5.069.473-.587.033-1.18.049-1.773.049-.321-1.267-.337-2.6-.364-3.9-.033-1.305.033-2.611.087-3.916 2.828-.419 5.651-.843 8.099-.702.185 1.169.288 2.507.386 3.835.098 1.305.114 2.611.152 3.922-.512.076-1.012.174-1.518.239zM96.802 240.61c-6.097-8.055-17.655-3.367-25.999-3.367-2.35 0-4.047.99-5.14 2.42-.984 1.071-1.637 2.513-1.659 4.378-.114 9.154-2.051 19.738 6.244 25.999 3.106 2.344 8.61 1.615 12.189 1.273 4.03-.386 8.039-1.061 12.026-1.735 2.132-.359 4.346-2.649 4.748-4.748.718-3.78.479-7.702.239-11.514-.233-3.835-.195-9.464-2.648-12.706zm-12.303 16.867c-1.681.223-3.378.37-5.069.473-.587.033-1.18.049-1.773.049-.321-1.273-.337-2.6-.364-3.905-.033-1.305.033-2.605.087-3.911 2.828-.419 5.651-.843 8.099-.702.185 1.169.288 2.507.386 3.835.098 1.305.114 2.616.152 3.922-.512.076-1.012.174-1.518.239zM143.752 158.029c-6.103-8.05-17.65-3.367-25.999-3.367-2.35 0-4.047.99-5.14 2.42-.984 1.072-1.637 2.513-1.659 4.378-.114 9.149-2.051 19.738 6.244 25.993 3.106 2.344 8.61 1.615 12.189 1.273 4.03-.386 8.039-1.061 12.026-1.735 2.132-.359 4.346-2.649 4.748-4.748.718-3.78.479-7.702.245-11.515-.239-3.833-.201-9.463-2.654-12.699zm-12.303 16.867a72.05 72.05 0 01-5.069.473c-.587.033-1.18.049-1.773.049-.321-1.267-.337-2.6-.364-3.9-.033-1.305.033-2.605.087-3.911 2.828-.419 5.651-.843 8.099-.702.179 1.169.288 2.502.386 3.835.092 1.305.114 2.611.152 3.922-.512.065-1.012.163-1.518.234zM143.752 199.317c-6.097-8.05-17.655-3.367-25.999-3.367-2.35 0-4.047.99-5.14 2.42-.984 1.071-1.637 2.513-1.659 4.378-.114 9.154-2.051 19.744 6.244 25.999 3.106 2.344 8.61 1.615 12.189 1.273 4.03-.386 8.039-1.061 12.026-1.735 2.132-.359 4.346-2.649 4.748-4.748.718-3.78.479-7.702.245-11.514-.239-3.835-.201-9.459-2.654-12.706zm-12.303 16.866a72.05 72.05 0 01-5.069.473c-.587.033-1.18.049-1.773.049-.321-1.267-.337-2.6-.364-3.9-.033-1.305.033-2.611.087-3.916 2.828-.419 5.651-.843 8.099-.702.185 1.169.288 2.507.386 3.835.092 1.305.114 2.611.152 3.922-.512.076-1.012.174-1.518.239zM143.752 240.61c-6.097-8.055-17.655-3.367-25.999-3.367-2.35 0-4.047.99-5.14 2.42-.984 1.071-1.637 2.513-1.659 4.378-.114 9.154-2.051 19.738 6.244 25.999 3.106 2.344 8.61 1.615 12.189 1.273 4.03-.386 8.039-1.061 12.026-1.735 2.132-.359 4.346-2.649 4.748-4.748.718-3.78.479-7.702.245-11.514-.239-3.835-.201-9.464-2.654-12.706zm-12.303 16.867a72.05 72.05 0 01-5.069.473c-.587.033-1.18.049-1.773.049-.321-1.273-.337-2.6-.364-3.905-.033-1.305.033-2.605.087-3.911 2.828-.419 5.651-.843 8.099-.702.185 1.169.288 2.507.386 3.835.092 1.305.114 2.616.152 3.922-.512.076-1.012.174-1.518.239zM190.702 158.029c-6.103-8.05-17.65-3.367-25.999-3.367-2.35 0-4.047.99-5.14 2.42-.984 1.072-1.637 2.513-1.659 4.378-.114 9.149-2.051 19.738 6.244 25.993 3.106 2.344 8.605 1.615 12.189 1.273 4.03-.386 8.034-1.061 12.026-1.735 2.132-.359 4.346-2.649 4.748-4.748.718-3.78.479-7.702.239-11.515-.233-3.833-.195-9.463-2.648-12.699zm-12.303 16.867a72.05 72.05 0 01-5.069.473c-.587.033-1.18.049-1.773.049-.321-1.267-.337-2.6-.364-3.9-.033-1.305.033-2.605.087-3.911 2.828-.419 5.657-.843 8.099-.702.179 1.169.288 2.502.386 3.835.098 1.305.114 2.611.152 3.922-.512.065-1.012.163-1.518.234zM190.702 199.317c-6.097-8.05-17.655-3.367-25.999-3.367-2.35 0-4.047.99-5.14 2.42-.984 1.071-1.637 2.513-1.659 4.378-.114 9.154-2.051 19.744 6.244 25.999 3.106 2.344 8.605 1.615 12.189 1.273 4.03-.386 8.034-1.061 12.026-1.735 2.132-.359 4.346-2.649 4.748-4.748.718-3.78.479-7.702.239-11.514-.233-3.835-.195-9.459-2.648-12.706zm-12.303 16.866a72.05 72.05 0 01-5.069.473c-.587.033-1.18.049-1.773.049-.321-1.267-.337-2.6-.364-3.9-.033-1.305.033-2.611.087-3.916 2.828-.419 5.657-.843 8.099-.702.185 1.169.288 2.507.386 3.835.098 1.305.114 2.611.152 3.922-.512.076-1.012.174-1.518.239zM190.702 240.61c-6.097-8.055-17.655-3.367-25.999-3.367-2.35 0-4.047.99-5.14 2.42-.984 1.071-1.637 2.513-1.659 4.378-.114 9.154-2.051 19.738 6.244 25.999 3.106 2.344 8.61 1.615 12.189 1.273 4.03-.386 8.034-1.061 12.026-1.735 2.132-.359 4.346-2.649 4.748-4.748.718-3.78.479-7.702.239-11.514-.233-3.835-.195-9.464-2.648-12.706zm-12.303 16.867a72.05 72.05 0 01-5.069.473c-.587.033-1.18.049-1.773.049-.321-1.273-.337-2.6-.364-3.905-.033-1.305.033-2.605.087-3.911 2.828-.419 5.657-.843 8.099-.702.185 1.169.288 2.507.386 3.835.098 1.305.114 2.616.152 3.922-.512.076-1.012.174-1.518.239zM237.652 158.029c-6.103-8.05-17.65-3.367-25.999-3.367-2.35 0-4.047.99-5.14 2.42-.984 1.072-1.637 2.513-1.659 4.378-.114 9.149-2.051 19.738 6.244 25.993 3.106 2.344 8.61 1.615 12.189 1.273 4.03-.386 8.039-1.061 12.031-1.735 2.132-.359 4.346-2.649 4.748-4.748.718-3.78.479-7.702.239-11.515-.244-3.833-.2-9.463-2.653-12.699zm-12.303 16.867a72.05 72.05 0 01-5.069.473c-.587.033-1.18.049-1.773.049-.321-1.267-.332-2.6-.364-3.9-.033-1.305.033-2.605.087-3.911 2.828-.419 5.657-.843 8.099-.702.18 1.169.288 2.502.386 3.835.098 1.305.114 2.611.152 3.922-.512.065-1.012.163-1.518.234zM237.652 199.317c-6.097-8.05-17.655-3.367-25.999-3.367-2.35 0-4.047.99-5.14 2.42-.984 1.071-1.637 2.513-1.659 4.378-.114 9.154-2.051 19.744 6.244 25.999 3.106 2.344 8.61 1.615 12.189 1.273 4.03-.386 8.039-1.061 12.031-1.735 2.132-.359 4.346-2.649 4.748-4.748.718-3.78.479-7.702.239-11.514-.244-3.835-.2-9.459-2.653-12.706zm-12.303 16.866a72.05 72.05 0 01-5.069.473c-.587.033-1.18.049-1.773.049-.321-1.267-.332-2.6-.364-3.9-.033-1.305.033-2.611.087-3.916 2.828-.419 5.657-.843 8.099-.702.185 1.169.288 2.507.386 3.835.098 1.305.114 2.611.152 3.922-.512.076-1.012.174-1.518.239zM237.652 240.61c-6.097-8.055-17.655-3.367-25.999-3.367-2.35 0-4.047.99-5.14 2.42-.984 1.071-1.637 2.513-1.659 4.378-.114 9.154-2.051 19.738 6.244 25.999 3.106 2.344 8.61 1.615 12.189 1.273 4.03-.386 8.039-1.061 12.031-1.735 2.132-.359 4.346-2.649 4.748-4.748.718-3.78.479-7.702.239-11.514-.244-3.835-.2-9.464-2.653-12.706zm-12.303 16.867a72.05 72.05 0 01-5.069.473c-.587.033-1.18.049-1.773.049-.321-1.273-.332-2.6-.364-3.905-.033-1.305.033-2.605.087-3.911 2.828-.419 5.657-.843 8.099-.702.185 1.169.288 2.507.386 3.835.098 1.305.114 2.616.152 3.922-.512.076-1.012.174-1.518.239z"></path>
      </g>
    </svg>
  );
}
export const Closet = ({className}) => {
  return (
    <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="currentcolor"
    ariaHidden="true"
    display="block"
    viewBox="0 0 32 32"
      className={className}
      style={{ height: 24, width: 24 }}
  >
    <path d="M25 1a3 3 0 012.995 2.824L28 4v22a3 3 0 01-2.824 2.995L25 29v2h-2v-2H9v2H7v-2a3 3 0 01-2.995-2.824L4 26V4a3 3 0 012.824-2.995L7 1h18zm1 20H6v5a1 1 0 00.883.993L7 27h18a1 1 0 00.993-.883L26 26v-5zm-10 2a1 1 0 110 2 1 1 0 010-2zm9-20h-8v16h9V4a1 1 0 00-.883-.993L25 3zM15 3H7a1 1 0 00-.993.883L6 4v15h9V3zm-3 8a1 1 0 110 2 1 1 0 010-2zm8 0a1 1 0 110 2 1 1 0 010-2z"></path>
  </svg>
  );
}

export const CookingBasics = ({className}) => {
  return (
    <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="currentcolor"
    ariaHidden="true"
    display="block"
    viewBox="0 0 32 32"
      className={className}
      style={{ height: 24, width: 24 }}
  >
    <path d="M26 1a5 5 0 015 5c0 6.389-1.592 13.187-4 14.693V31h-2V20.694c-2.364-1.478-3.942-8.062-3.998-14.349L21 6l.005-.217A5 5 0 0126 1zm-9 0v18.118c2.317.557 4 3.01 4 5.882 0 3.27-2.183 6-5 6s-5-2.73-5-6c0-2.872 1.683-5.326 4-5.882V1zM2 1h1c4.47 0 6.934 6.365 6.999 18.505L10 21H3.999L4 31H2zm14 20c-1.602 0-3 1.748-3 4s1.398 4 3 4 3-1.748 3-4-1.398-4-3-4zM4 3.239V19h3.995l-.017-.964-.027-.949C7.673 9.157 6.235 4.623 4.224 3.364l-.12-.07zm19.005 2.585L23 6l.002.31c.045 4.321 1.031 9.133 1.999 11.39V3.17a3.002 3.002 0 00-1.996 2.654zm3.996-2.653v14.526C27.99 15.387 29 10.4 29 6a3.001 3.001 0 00-2-2.829z"></path>
  </svg>
  );
}

export const Dishes = ({className}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="currentcolor"
      ariaHidden="true"
      display="block"
      viewBox="0 0 32 32"
      className={className}
      style={{ height: 24, width: 24 }}
    >
      <path d="M29 1v2c-7.18 0-13 5.82-13 13 0 7.077 5.655 12.833 12.693 12.996L29 29v2c-8.284 0-15-6.716-15-15 0-8.18 6.547-14.83 14.686-14.997zM3 1h2v6h2V1h2v6h2V1h2v9a5.002 5.002 0 01-3.999 4.9L9 31H7V14.9a5.01 5.01 0 01-3.978-4.444l-.017-.232L3 10zm26 6v2a7 7 0 00-.24 13.996L29 23v2a9 9 0 01-.265-17.996zM10.999 9h-6v.975l.005.176a3 3 0 005.99.025L11 10z"></path>
    </svg>
  );
}
export const Door = ({className}) =>  {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="970.667"
      height="1706.667"
      version="1"
      viewBox="0 0 728 1280"
      className={className}
    >
      <path
        d="M2690 12794c-1290-21-2279-77-2458-138-22-8-42-23-50-39-73-149-122-1197-164-3492-16-893-16-4570 0-5460C54 1694 95 658 152 293c8-54 8-76-1-86C81 122 680 65 2100 18c507-16 2556-16 3055 0 1178 39 1809 87 1925 147 24 12 28 23 43 122 62 396 101 1347 139 3388 16 880 16 4592 0 5470-37 2011-79 3046-137 3377-7 43-11 86-8 97 4 15-4 22-44 34-169 55-740 95-1803 127-324 10-2204 20-2580 14zm-2346-229c282-45 946-82 1911-106 543-13 2246-13 2800 1 1023 24 1735 66 1974 116 30 6 33 5 28-12-105-343-183-4064-157-7462 21-2776 78-4532 157-4851 5-21 3-23-13-17-135 55-960 110-2044 137-587 15-2155 15-2740 0-953-24-1676-67-1950-115-41-8-77-12-78-11-2 2 1 34 7 72 135 874 193 6716 101 10163-31 1154-70 1859-116 2084-5 25-4 28 11 22 10-3 59-13 109-21z"
        transform="matrix(.1 0 0 -.1 0 1280)"
      ></path>
      <path
        d="M3195 11823c-1027-11-1933-70-2103-138-30-12-41-23-45-43-3-15-14-70-26-122-44-205-83-731-101-1380-33-1175 33-2543 133-2782 13-31 22-38 69-51 293-82 1207-130 2478-130 1168 0 2035 40 2395 110 127 24 151 37 180 96 53 110 93 467 127 1137 16 326 16 1654 0 1980-29 564-57 868-98 1045-31 130-43 141-194 168-409 74-1658 123-2815 110zm2895-227c0-3-7-38-15-78-66-311-105-1054-105-2008 0-1020 42-1775 115-2055 9-32 14-59 13-61-2-1-27 4-57 12-159 41-614 77-1321 106-398 16-1831 16-2230 0-724-29-1185-67-1332-108-15-4-15 0-3 53 92 398 138 1859 95 2978-21 528-49 859-96 1119l-7 39 34-6c646-112 2537-151 3944-82 442 22 793 54 915 84 44 11 50 12 50 7zM5961 6924c-216-58-361-246-361-469 0-371 379-598 715-428 27 14 77 53 111 87 165 166 188 414 57 614-109 165-329 248-522 196zM2940 5514c-757-15-1489-62-1725-110-140-28-161-48-189-182-72-330-110-1031-110-2012 0-1057 45-1813 125-2082 17-60 24-70 57-86 124-63 553-106 1412-144 368-16 1778-16 2155 0 847 37 1291 83 1414 147 37 18 57 63 81 177 70 330 110 1063 111 1988 0 1069-54 1859-144 2115-12 35-20 42-63 56-147 50-589 90-1314 119-252 10-1511 20-1810 14zm-1735-234c113-26 471-60 840-80 841-45 2257-45 3100 0 387 21 833 65 867 86 11 7 11 6-12-104-122-607-147-2610-44-3617 17-169 48-368 63-408 12-31 7-33-49-17-153 42-695 86-1365 112-408 15-1647 15-2045 0-674-27-1131-63-1343-108-38-8-70-14-71-14-2 0 5 39 15 88 34 161 66 542 91 1072 15 328 15 1488 0 1825-27 597-62 969-107 1148-8 31-3 32 60 17z"
        transform="matrix(.1 0 0 -.1 0 1280)"
      ></path>
    </svg>
  );
}
export const Hairdrier = ({className}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="currentcolor"
      ariaHidden="true"
      display="block"
      viewBox="0 0 32 32"
      className={className}
      style={{ height: 24, width: 24 }}
    >
      <path d="M14 27l-.005.2a4 4 0 01-3.789 3.795L10 31H4v-2h6l.15-.005a2 2 0 001.844-1.838L12 27zM10 1c.536 0 1.067.047 1.58.138l.38.077 17.448 3.64a2 2 0 011.585 1.792l.007.166v6.374a2 2 0 01-1.431 1.917l-.16.04-13.554 2.826 1.767 6.506a2 2 0 01-1.753 2.516l-.177.008H11.76a2 2 0 01-1.879-1.315l-.048-.15-1.88-6.769A9 9 0 0110 1zm5.692 24l-1.799-6.621-1.806.378a8.998 8.998 0 01-1.663.233l-.331.008L11.76 25zM10 3a7 7 0 101.32 13.875l.331-.07L29 13.187V6.813L11.538 3.169A7.027 7.027 0 0010 3zm0 2a5 5 0 110 10 5 5 0 010-10zm0 2a3 3 0 100 6 3 3 0 000-6z"></path>
    </svg>
  );
}

export const Hanger = ({className}) => {
  return (
    <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="currentcolor"
    ariaHidden="true"
    display="block"
    viewBox="0 0 32 32"
      className={className}
      style={{ height: 24, width: 24 }}
  >
    <path d="M16 2a5 5 0 011.661 9.717 1.002 1.002 0 00-.653.816l-.008.126v.813l13.23 9.052a3 3 0 011.299 2.279l.006.197a3 3 0 01-3 3H3.465a3 3 0 01-1.694-5.476L15 13.472v-.813c0-1.211.724-2.285 1.816-2.757l.176-.07a3 3 0 10-3.987-3.008L13 7h-2a5 5 0 015-5zm0 13.211L2.9 24.175A1 1 0 003.465 26h25.07a1 1 0 00.565-1.825z"></path>
  </svg>
  );
}

export const Iron = ({className}) => {
  return (
    <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="currentcolor"
    ariaHidden="true"
    display="block"
    viewBox="0 0 32 32"
      className={className}
      style={{ height: 24, width: 24 }}
  >
    <path d="M12 28a1 1 0 110 2 1 1 0 010-2zm4 0a1 1 0 110 2 1 1 0 010-2zm4 0a1 1 0 110 2 1 1 0 010-2zm-6-3a1 1 0 110 2 1 1 0 010-2zm4 0a1 1 0 110 2 1 1 0 010-2zM16.027 3l.308.004a12.493 12.493 0 0111.817 9.48l.07.3 1.73 7.782.027.144a2 2 0 01-1.83 2.285L28 23H2.247l-.15-.005a2 2 0 01-1.844-1.838L.247 21v-7l.004-.217a5 5 0 014.773-4.778L5.247 9h9V5h-14V3zm11.528 16H2.245l.002 2H28zM16.247 5.002V11h-11l-.177.005a3 3 0 00-2.818 2.819L2.247 14l-.001 3H27.11l-.84-3.783-.067-.28a10.494 10.494 0 00-9.596-7.921l-.292-.012z"></path>
  </svg>
  );
}
export const Kitchen = ({className}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="currentcolor"
      ariaHidden="true"
      display="block"
      viewBox="0 0 32 32"
      className={className}
      style={{ height: 24, width: 24 }}
    >
      <path d="M26 1a5 5 0 015 5c0 6.389-1.592 13.187-4 14.693V31h-2V20.694c-2.364-1.478-3.942-8.062-3.998-14.349L21 6l.005-.217A5 5 0 0126 1zm-9 0v18.118c2.317.557 4 3.01 4 5.882 0 3.27-2.183 6-5 6s-5-2.73-5-6c0-2.872 1.683-5.326 4-5.882V1zM2 1h1c4.47 0 6.934 6.365 6.999 18.505L10 21H3.999L4 31H2zm14 20c-1.602 0-3 1.748-3 4s1.398 4 3 4 3-1.748 3-4-1.398-4-3-4zM4 3.239V19h3.995l-.017-.964-.027-.949C7.673 9.157 6.235 4.623 4.224 3.364l-.12-.07zm19.005 2.585L23 6l.002.31c.045 4.321 1.031 9.133 1.999 11.39V3.17a3.002 3.002 0 00-1.996 2.654zm3.996-2.653v14.526C27.99 15.387 29 10.4 29 6a3.001 3.001 0 00-2-2.829z"></path>
    </svg>
  );
}
export const Lake = ({className}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="currentcolor"
      ariaHidden="true"
      display="block"
      viewBox="0 0 32 32"
      className={className}
      style={{ height: 24, width: 24 }}
    >
      <path d="M28 2a2 2 0 012 2v24a2 2 0 01-2 2H4a2 2 0 01-2-2V4a2 2 0 012-2zm0 2H4v15.499l.187-.007c.371-.033.72-.161 1.005-.372l.137-.111A3.975 3.975 0 018 18c.988 0 1.945.352 2.671 1.009.35.316.826.49 1.33.491.502 0 .979-.175 1.328-.492A3.974 3.974 0 0116 18a3.97 3.97 0 012.671 1.009c.35.316.826.49 1.33.491.502 0 .979-.175 1.328-.491A3.975 3.975 0 0123.999 18a3.97 3.97 0 012.672 1.009c.35.316.827.49 1.33.491l-.001 2-.228-.006a3.96 3.96 0 01-2.443-1.003A1.978 1.978 0 0024 20c-.502 0-.978.175-1.328.491a3.977 3.977 0 01-2.67 1.009 3.977 3.977 0 01-2.672-1.009A1.978 1.978 0 0016 20c-.503 0-.98.175-1.329.491a3.978 3.978 0 01-2.67 1.009 3.978 3.978 0 01-2.672-1.008A1.978 1.978 0 008 20c-.503 0-.98.175-1.33.491A3.976 3.976 0 014 21.5v2.999l.187-.007c.371-.033.72-.161 1.005-.372l.137-.111A3.975 3.975 0 018 23c.988 0 1.945.352 2.671 1.009.35.316.826.49 1.33.491.502 0 .979-.175 1.328-.492A3.974 3.974 0 0116 23a3.97 3.97 0 012.671 1.009c.35.316.826.49 1.33.491.502 0 .979-.175 1.328-.491A3.975 3.975 0 0123.999 23a3.97 3.97 0 012.672 1.009c.35.316.827.49 1.33.491l-.001 2-.228-.006a3.96 3.96 0 01-2.443-1.003A1.978 1.978 0 0024 25c-.502 0-.978.175-1.328.491a3.977 3.977 0 01-2.67 1.009 3.977 3.977 0 01-2.672-1.009A1.978 1.978 0 0016 25c-.503 0-.98.175-1.329.491a3.978 3.978 0 01-2.67 1.009 3.978 3.978 0 01-2.672-1.008A1.978 1.978 0 008 25c-.503 0-.98.175-1.33.491A3.976 3.976 0 014 26.5V28h24zm-6 3a3 3 0 110 6 3 3 0 010-6zm0 2a1 1 0 100 2 1 1 0 000-2z"></path>
    </svg>
  );
}

export const Oven = ({className}) => {
  return (
    <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="currentcolor"
    ariaHidden="true"
    display="block"
    viewBox="0 0 32 32"
      className={className}
      style={{ height: 24, width: 24 }}
  >
    <path d="M28 2a2 2 0 011.995 1.85L30 4v24a2 2 0 01-1.85 1.995L28 30H4a2 2 0 01-1.995-1.85L2 28V4a2 2 0 011.85-1.995L4 2zm0 10H4v16h24zm-2 2v12H6V14zm-2 2H8v8h16zm4-12H4v6h24zm-3 2a1 1 0 110 2 1 1 0 010-2zm-6 0a1 1 0 110 2 1 1 0 010-2zm-6 0a1 1 0 110 2 1 1 0 010-2zM7 6a1 1 0 110 2 1 1 0 010-2z"></path>
  </svg>
  );
}
export const Parking = ({className}) => {
  return (
    <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="currentcolor"
    ariaHidden="true"
    display="block"
    viewBox="0 0 32 32"
      className={className}
      style={{ height: 24, width: 24 }}
  >
    <path d="M26 19a1 1 0 11-2 0 1 1 0 012 0zM7 18a1 1 0 100 2 1 1 0 000-2zm20.693-5l.42 1.119C29.253 15.036 30 16.426 30 18v9c0 1.103-.897 2-2 2h-2c-1.103 0-2-.897-2-2v-2H8v2c0 1.103-.897 2-2 2H4c-1.103 0-2-.897-2-2v-9c0-1.575.746-2.965 1.888-3.882L4.308 13H2v-2h3v.152l1.82-4.854A2.009 2.009 0 018.693 5h14.614c.829 0 1.58.521 1.873 1.297L27 11.151V11h3v2h-2.307zM6 25H4v2h2v-2zm22 0h-2v2h2v-2zm0-2v-5c0-1.654-1.346-3-3-3H7c-1.654 0-3 1.346-3 3v5h24zm-3-10h.557l-2.25-6H8.693l-2.25 6H25zm-15 7h12v-2H10v2z"></path>
  </svg>
  );
}

export const Refrigirator = ({className}) => {
  return (
    <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="currentcolor"
    ariaHidden="true"
    display="block"
    viewBox="0 0 32 32"
      className={className}
      style={{ height: 24, width: 24 }}
  >
    <path d="M25 1a2 2 0 011.995 1.85L27 3v26a2 2 0 01-1.85 1.995L25 31H7a2 2 0 01-1.995-1.85L5 29V3a2 2 0 011.85-1.995L7 1zm0 10H7v18h18zm-15 2a1 1 0 110 2 1 1 0 010-2zM25 3H7v6h18zM10 5a1 1 0 110 2 1 1 0 010-2z"></path>
  </svg>
  );
}
export const Stove = ({className}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="currentcolor"
      ariaHidden="true"
      display="block"
      viewBox="0 0 32 32"
      className={className}
      style={{ height: 24, width: 24 }}
    >
      <path d="M27 0a2 2 0 011.995 1.85L29 2v26a2 2 0 01-1.85 1.995L27 30H5a2 2 0 01-1.995-1.85L3 28V2A2 2 0 014.85.005L5 0zm0 2H5v26h22zm-3 22a1 1 0 110 2 1 1 0 010-2zm-5.333 0a1 1 0 110 2 1 1 0 010-2zm-5.334 0a1 1 0 110 2 1 1 0 010-2zM8 24a1 1 0 110 2 1 1 0 010-2zm13-10a4 4 0 110 8 4 4 0 010-8zm-10 0a4 4 0 110 8 4 4 0 010-8zm10 2a2 2 0 100 4 2 2 0 000-4zm-10 0a2 2 0 100 4 2 2 0 000-4zM21 4a4 4 0 110 8 4 4 0 010-8zM11 4a4 4 0 110 8 4 4 0 010-8zm10 2a2 2 0 100 4 2 2 0 000-4zM11 6a2 2 0 100 4 2 2 0 000-4z"></path>
    </svg>
  );
}
export const TV = ({className}) => {
  return (
    <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="currentcolor"
    ariaHidden="true"
    display="block"
    viewBox="0 0 32 32"
      className={className}
      style={{ height: 24, width: 24 }}
  >
    <path d="M9 29v-2h2v-2H6a5 5 0 01-4.995-4.783L1 20V8a5 5 0 014.783-4.995L6 3h20a5 5 0 014.995 4.783L31 8v12a5 5 0 01-4.783 4.995L26 25h-5v2h2v2zm10-4h-6v2h6zm7-20H6a3 3 0 00-2.995 2.824L3 8v12a3 3 0 002.824 2.995L6 23h20a3 3 0 002.995-2.824L29 20V8a3 3 0 00-2.824-2.995z"></path>
  </svg>
  );
}
export const Washer = ({className}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="currentcolor"
      ariaHidden="true"
      display="block"
      className={className}
      viewBox="0 0 32 32"
      style={{ height: 24, width: 24 }}
    >
      <path d="M16 20.333a3.667 3.667 0 110 7.334 3.667 3.667 0 010-7.334zm0 2a1.667 1.667 0 100 3.334 1.667 1.667 0 000-3.334zM16 15a9 9 0 018.043 4.958L22.53 21.47a7.003 7.003 0 00-13.058 0l-1.514-1.513A9 9 0 0116 15zm0-5.333c4.98 0 9.368 2.54 11.937 6.396L26.49 17.51c-2.175-3.507-6.06-5.843-10.49-5.843S7.685 14.003 5.51 17.51l-1.446-1.447A14.32 14.32 0 0116 9.667zm0-5.334c6.451 0 12.177 3.106 15.763 7.904l-1.43 1.431C27.122 9.225 21.898 6.333 16 6.333c-5.9 0-11.123 2.892-14.332 7.334l-1.43-1.43C3.824 7.438 9.549 4.332 16 4.332z"></path>
    </svg>
  );
}

export const Wifi = ({className}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="currentcolor"
      ariaHidden="true"
      display="block"
      viewBox="0 0 32 32"
      className={className}
      style={{ height: 24, width: 24 }}
    >
      <path d="M16 20.333a3.667 3.667 0 110 7.334 3.667 3.667 0 010-7.334zm0 2a1.667 1.667 0 100 3.334 1.667 1.667 0 000-3.334zM16 15a9 9 0 018.043 4.958L22.53 21.47a7.003 7.003 0 00-13.058 0l-1.514-1.513A9 9 0 0116 15zm0-5.333c4.98 0 9.368 2.54 11.937 6.396L26.49 17.51c-2.175-3.507-6.06-5.843-10.49-5.843S7.685 14.003 5.51 17.51l-1.446-1.447A14.32 14.32 0 0116 9.667zm0-5.334c6.451 0 12.177 3.106 15.763 7.904l-1.43 1.431C27.122 9.225 21.898 6.333 16 6.333c-5.9 0-11.123 2.892-14.332 7.334l-1.43-1.43C3.824 7.438 9.549 4.332 16 4.332z"></path>
    </svg>
  );
}
export const Yard = ({className}) => {
  return (
    <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="currentcolor"
    ariaHidden="true"
    display="block"
    viewBox="0 0 32 32"
      className={className}
      style={{ height: 24, width: 24 }}
  >
    <path d="M16 1a5 5 0 015 5 5 5 0 010 10 5.002 5.002 0 01-4 4.9v4.287C18.652 23.224 21.153 22 23.95 22a8.94 8.94 0 013.737.814l.313.15.002 2.328A6.963 6.963 0 0023.95 24c-3.542 0-6.453 2.489-6.93 5.869l-.02.15-.006.098a1 1 0 01-.876.876L16 31a1 1 0 01-.974-.77l-.02-.124C14.635 26.623 11.615 24 7.972 24a6.963 6.963 0 00-3.97 1.234l.002-2.314c1.218-.6 2.57-.92 3.968-.92 2.818 0 5.358 1.24 7.028 3.224V20.9a5.002 5.002 0 01-3.995-4.683L11 16l-.217-.005a5 5 0 010-9.99L11 6l.005-.217A5 5 0 0116 1zm2.864 14.1c-.811.567-1.799.9-2.864.9s-2.053-.333-2.864-.9l-.062.232a3 3 0 105.851.001zM11 8a3 3 0 10.667 5.926l.234-.062A4.977 4.977 0 0111 11c0-1.065.333-2.053.9-2.864l-.232-.062A3.013 3.013 0 0011 8zm10 0c-.228 0-.45.025-.667.074l-.234.062C20.667 8.947 21 9.935 21 11a4.977 4.977 0 01-.9 2.864l.232.062A3 3 0 1021 8zm-5 0a3 3 0 100 6 3 3 0 000-6zm0-5a3 3 0 00-2.926 3.667l.062.234C13.947 6.333 14.935 6 16 6s2.053.333 2.864.9l.062-.232A3 3 0 0016 3z"></path>
  </svg>
  );
}
export const Smoking = ({className}) => {

return (
   <svg className={className}  style={{ height: 24, width: 24,     paddingRight: '5px'   }} enable-background="new 0 0 512 512" version="1.1" viewBox="0 0 512 512"  xmlns="http://www.w3.org/2000/svg">
    <polygon points="0 299.3 0 390.25 411.32 403.33 411.32 286.22"/>
    <polygon points="444.71 285.16 444.71 404.39 512 406.53 512 283.02"/>
    <path d="m444.1 157.99c0-9.128 1.934-12.931 4.864-18.69 3.783-7.438 8.493-16.696 8.493-33.828h-33.391c0 9.127-1.935 12.931-4.864 18.69-3.783 7.438-8.493 16.696-8.493 33.829 0 17.132 4.708 26.389 8.493 33.829 2.93 5.759 4.864 9.562 4.864 18.69 0 9.125-1.935 12.928-4.863 18.686-3.784 7.438-8.494 16.696-8.494 33.826h33.391c0-9.126 1.934-12.929 4.863-18.686 3.785-7.44 8.494-16.697 8.494-33.828 0-17.132-4.708-26.389-8.493-33.829-2.929-5.758-4.864-9.561-4.864-18.689z"/>
    <path d="m501.41 183.96c0-5.881 1.074-7.992 3.213-12.197 2.887-5.677 6.841-13.45 6.841-27.335h-33.391c0 5.88-1.074 7.992-3.213 12.197-2.887 5.677-6.841 13.45-6.841 27.336s3.955 21.659 6.841 27.336c2.139 4.205 3.213 6.315 3.213 12.197 0 5.879-1.074 7.989-3.212 12.193-2.887 5.673-6.842 13.448-6.842 27.332h33.391c0-5.879 1.074-7.989 3.212-12.193 2.888-5.675 6.842-13.449 6.842-27.334s-3.955-21.659-6.841-27.335c-2.139-4.206-3.213-6.316-3.213-12.197z"/>
</svg>

)
}